import { useEffect, useState, } from 'react';

import { Table, } from 'react-bootstrap';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';

import './styles.css';

import { listCompanies, } from '../../services/api';

import NavBar from '../../components/NavBar/NavBar';
import CorpoEmpresas from '../../components/Companies';


function Empresas() {
  const [body, setBody] = useState([])


  useEffect(() => {
    localStorage.removeItem('name_empresa');
    localStorage.removeItem('name_host');

    listCompanies(true)
      .then(({ data, }) => {
        setBody(data);
      });
  }, []);


  return (
    <NavBar >
      <TableContainer component={Paper} elevation={8}>
        <Table>
          <thead>
            <tr>
              <th>Nome da empresa</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          {body
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((body) => {
              return <CorpoEmpresas key={body.id} data={body} />
            })}
        </Table>
      </TableContainer>
      <br />
    </NavBar>
  );
}

export default Empresas;
